import { createReducer, createSlice, combineReducers, createAsyncThunk } from "@reduxjs/toolkit";
import {createAction} from 'redux-actions';
import { defaultPublicTrackingUrl } from 'src/shared/urls.jsx'

export const trackUserEvent = createAction("TRACK_USER_EVENT")
export const clearTrackedHotspotClicks = createAction("CLEAR_TRACKED_HOTSPOT_CLICKS")
export const setTrackingInterval = createAction("SET_TRACKING_INTERVAL")
export const setIsSendingTrackingData = createAction("SET_IS_SENDING_TRACKING_DATA")

export const sendTrackingData = createAsyncThunk(
  'SEND_TRACKING_DATA',
  async (_, thunkAPI) => {
    console.debug("THUNK")
    const {state, dispatch} = thunkAPI
    const tagOwner = state.tagOwner

    const trackingUrl = (state.trackingUrl || defaultPublicTrackingUrl).replace("@tag_owner_id@", tagOwner.id)
    const trackedHotspotClicks = state.trackedHotspotClicks
    const trackingInterval = (state.trackingInterval || 30) * 1000
    const isSendingTrackingData = state.isSendingTrackingData

    return new Promise((resolve, reject) => {
      if (trackingUrl) {
        if(trackedHotspotClicks && trackedHotspotClicks.length > 0) {
          if (!isSendingTrackingData) {
            axios({
              url: trackingUrl,
              method: "post",
              data: {clicked_hotspots: trackedHotspotClicks},
              timeout: trackingInterval - 1000
            }).then((response) => {
              console.log(response.data)
              if (response.data.status == "OK") {
                dispatch(clearTrackedHotspotClicks(response.data.savedTimestamps))
                if (trackingInterval != (response.data.trackingInterval * 1000)) {
                  dispatch(setTrackingInterval(response.data.trackingInterval))
                }
              }
              resolve(response)
            }).catch(exception => {
              console.error(exception)
              reject(exception)
            }).finally(() => {
              dispatch(setIsSendingTrackingData(false))
              console.debug("FINALLY")
            });
          } else {
            resolve(response)
          }
        } else {
          resolve(response)
        }
      } else {
        console.error("NO TRACKING URL PROVIDED")
      }
    })
  }
)


const reducer = createReducer({}, {
  [clearTrackedHotspotClicks]: (state, action) => {
    state.trackedHotspotClicks = state.trackedHotspotClicks.filter((trackedHotspotClick) => !action.payload.some(savedTimestamp => trackedHotspotClick.created_at == savedTimestamp))
  },
  [setIsSendingTrackingData]: (state, action) => {
    state.isSendingTrackingData = action.payload
  },

  [setTrackingInterval]: (state, action) => { 
    try {
      state.trackingInterval = parseInt(action.payload)

      if(state.trackingInterval == null || state.trackingInterval < 1) {
        state.trackingInterval = 90
      }
    } catch(ex) {
      state.trackingInterval = 90
    }
  },
  [trackUserEvent]: (state, action) => {
    if(state.trackedHotspotClicks == undefined) {
      state.trackedHotspotClicks = []
    }
    const clientEpochTime = Math.round((new Date()).getTime() / 1000);

    state.trackedHotspotClicks.push({
      ...action.payload,
      created_at: clientEpochTime + (state.serverTimeDifference || 0)
    })
  },


  ["CABLE_EVENT_UPDATED"]: (state, action) => {
    state.events = state.events.filter((scm) => action.payload.id !== scm.id)
    state.events = state.events.concat(action.payload)
  },
  ["CABLE_HTML_CONTENT_UPDATED"]: (state, action) => {
    if(state.htmlContents === undefined)
      state.htmlContents = []
    state.htmlContents = state.htmlContents.filter((scm) => action.payload.id !== scm.id)
    state.htmlContents = state.htmlContents.concat(action.payload)
  },
  ["CABLE_VIDEO_ROOM_UPDATED"]: (state, action) => {
    state.videoRooms = state.videoRooms.filter((scm) => action.payload.id !== scm.id)
    state.videoRooms = state.videoRooms.concat(action.payload)
  },
  ["CABLE_TAG_OWNER_UPDATED"]: (state, action) => {
    state.tagOwner = action.payload
  },
["CABLE_CHAT_MESSAGE_CREATED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id),
        action.payload
      ]
    }
  },
  ["CABLE_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id),
        action.payload
      ]
    }
  },
  ["CABLE_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id)
      ]
    }
  },
  ["CABLE_PUSH_MESSAGE_NOTIFICATION"]: (state, action) => {
    state.push_notifications.push(action.payload)
  },

  ["CABLE_BET_UPDATED"]: (state, action) => {
    state.bets[action.payload.id] = action.payload
  },
  ["CABLE_BETTING_CREATED"]: (state, action) => {
    state.bettings.push(action.payload)
  },
  ["CABLE_BETTING_DESTROYED"]: (state, action) => {
    state.bettings.splice(state.bettings.findIndex((betting) => betting.id == action.payload.id), 1)
  },
  ["CABLE_ACCOUNT_ORGANIZATION_CREATED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
    state.accountOrganizations.push(action.payload)
  },
  ["CABLE_ACCOUNT_ORGANIZATION_UPDATED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
    state.accountOrganizations.push(action.payload)
  },
  ["CABLE_ACCOUNT_ORGANIZATION_DESTROYED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_SESSION_CREATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_UPDATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_DESTROYED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_MESSAGE_CREATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
  },

  ["CABLE_IMAGE_MAP_CONFIG_CREATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
    state.imageMapConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_CONFIG_UPDATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
    state.imageMapConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_CONFIG_DESTROYED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
  },

  ["CABLE_IMAGE_MAP_CREATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
    state.imageMaps.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_UPDATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
    state.imageMaps.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_DESTROYED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_CONFIG_CREATED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
    state.imageHotspotConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_UPDATED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
    state.imageHotspotConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_DESTROYED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
  },
  ["CABLE_EVENT_QUESTION_CREATED"]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((scm) => action.payload.id !== scm.id)
    state.eventQuestions = state.eventQuestions.concat(action.payload)
  },
  ["CABLE_EVENT_QUESTION_UPDATED"]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((im) => im.id !== action.payload.id)
    state.eventQuestions.push(action.payload)
  },
  ["CABLE_EVENT_QUESTION_DESTROYED"]: (state, action) => {
    console.log("hihihihihi")
    state.eventQuestions = state.eventQuestions.filter((im) => im.id !== action.payload.id)
  },
  ["CABLE_IMAGE_HOTSPOT_CREATED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
    state.imageHotspots.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_UPDATED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
    state.imageHotspots.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DESTROYED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
  },

  ["CABLE_MEDIA_FILE_CREATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_UPDATED"]: (state, action) => {
    if (!state.mediaFiles) { // IDK how good this is but just so it wont crash later on filtering
      state.mediaFiles = []
    }

    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_DESTROYED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_CREATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_CREATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_CREATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_UPDATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_DESTROYED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
  },
  ["CABLE_WORD_CLOUD_CREATED"]: (state, action) => {
    state.wordClouds = state.wordClouds.filter((mf) => mf.id !== action.payload.id)
    state.wordClouds.push(action.payload)
  },
  ["CABLE_WORD_CLOUD_UPDATED"]: (state, action) => {
    state.wordClouds = state.wordClouds.filter((mf) => mf.id !== action.payload.id)
    state.wordClouds.push(action.payload)
  },
  ["CABLE_WORD_CLOUD_DESTROYED"]: (state, action) => {
    state.wordClouds = state.wordClouds.filter((mf) => mf.id !== action.payload.id)
  },
  ["CABLE_SERVER_SETTING_UPDATED"]: (state, action) => {
    state.serverSettings = action.payload
  },
  ["CABLE_WORD_CLOUD_CONFIG_CREATED"]: (state, action) => {
    state.wordCloudConfigs = state.wordCloudConfigs.filter((mf) => mf.id !== action.payload.id)
    state.wordCloudConfigs.push(action.payload)
  },
  ["CABLE_WORD_CLOUD_CONFIG_UPDATED"]: (state, action) => {
    state.wordCloudConfigs = state.wordCloudConfigs.filter((mf) => mf.id !== action.payload.id)
    state.wordCloudConfigs.push(action.payload)
  },
  ["CABLE_WORD_CLOUD_CONFIG_DESTROYED"]: (state, action) => {
    state.wordCloudConfigs = state.wordCloudConfigs.filter((mf) => mf.id !== action.payload.id)
  }
})
export default reducer //combineReducers({videoPlayer: reducer})